import { NodeInterface } from "@swivl-mono/types";

import React from "react";
import { FaMinusCircle } from "react-icons/fa";
import TabNodeLayoutData from "../NodeLayouts/TabNodeLayoutData";
import InspectorNodeHeader from "../SidePanel/Inspector/components/InspectorNodeHeader";
import NodePanel from "./NodePanel";
import { Dropdown } from "@swivl-mono/ui";
import { RandomId } from "@swivl-mono/helpers";


class TimeSelect extends React.Component<any> {
  constructor(props) {
    super(props)
    this.deleteClicked = this.deleteClicked.bind(this)
    this.onChange = this.onChange.bind(this)
  }
  onChange(e:any) {
    var condition = this.props.condition;

    if (e.target.name === "value") {
      let intVal = parseInt(e.target.value);
      if (Number.isInteger(intVal)) {
        condition[e.target.name] = intVal;
      }
    } else  {
      condition[e.target.name] = e.target.value;
    }
    this.props.updateCondition(condition)
  }
  deleteClicked() {
    this.props.removeCondition(this.props.condition)
  }
  render() {
    const dropdownOptions = [ {value: "minutes",  label: "Minutes", id: "minutes"},
                              {value: "hours",  label: "Hours", id: "hours"},
                              {value: "days",  label: "Days", id: "days"} ];

    return <div className="timeSelectComponent">
        <div className="titleRow">{this.props.title}<div className="removeTimeSelectButton" onClick={this.deleteClicked} ><FaMinusCircle/></div></div>

        <div className="inputRow">
          <div className="textInput">
            <input name="value" placeholder="Enter #..." value={this.props.value} onChange={this.onChange}/>
          </div>
          <div className="dropDown">
            <Dropdown options={dropdownOptions} name="unit" value={this.props.unit} onChange={this.onChange} />
          </div>
        </div>
    </div>;
   }
};


const RouterStart = {
  Type: "routerStart",
  Empty: function() {
          return {
              "id": RandomId(6),
              "type": RouterStart.Type,
              "newUserGoto": null,
              "returningUserGoto": null,
              "returningAfter":[]
            }
    },

    PlumbData: function(node:NodeInterface) {
      let tabs:any = []


        tabs.push(  {
          id:"newUserGoto",
          title:"New User",
          "source": "newUserGoto",
          "target": node.newUserGoto,
        })
        

      var returningUserText = "Returning User";

      for (var i = 0; i < node.returningAfter.length; i++) {
        var condition = node.returningAfter[i];
        var text  = "";
        var s = (condition.value === 1) ? "" : "s"
        if (condition.unit === "minutes") {
          text  = "Returning < " + condition.value + " Minute" + s;
          returningUserText = "Returning After " + condition.value + " Minute" + s; ;

        }
        if (condition.unit === "hours") {
          text  = "Returning < " + condition.value + " Hour" + s;
          returningUserText = "Returning After " + condition.value + " Hour" + s; ;
        }
        if (condition.unit === "days") {
          text  = "Returning < " + condition.value + " Day" + s;
          returningUserText = "Returning After " + condition.value + " Day" + s; ;
        }


          tabs.push(  {
            "id":  "returningAfter_" + condition.id,
            title:text,
          "source": "returningAfter_"+i+ "_goto",
          target:condition.goto
          })


      }


              tabs.push(  {
              id:"returningUserGoto",
              title:returningUserText,
              source:"returningUserGoto",
              target:node.returningUserGoto
              })



             





    return TabNodeLayoutData({
      node: node,
      hideInput: true,
      title: "Start",
      baseWidth: 120,
      tabTitleHeight:40,

      tabs:tabs
    });


      // return data;
    },


   InspectorPanel: class RouterStartStartInspectorPanel extends NodePanel{
     constructor(props:any) {       super(props);
       this.onChange = this.onChange.bind(this)
       this.addConditionClicked = this.addConditionClicked.bind(this)
       this.updateCondition = this.updateCondition.bind(this)
       this.removeCondition = this.removeCondition.bind(this)
     }

     onChange(event:any) {
       let node =  JSON.parse(JSON.stringify(this.props.node));
       if (event.target.value) {
         node[event.target.name] = ""; // Create
         node[event.target.name] = null; // Set to null
       } else {
         delete node[event.target.name]
       }



       this.props.updateNode(node, this.props.node, true)


     }

     updateCondition(condition) {
       var node = this.props.node;
       var returningAfter = node.returningAfter;
       for (var i = 0; i < returningAfter.length; i++) {
         if (returningAfter[i].value === condition.value && returningAfter[i].unit === condition.unit && returningAfter[i].id !== condition.id ) {
           alert("You can not have two conditions with the same amount of time");
           return;
         }
         if (returningAfter[i].id === condition.id ) {
           returningAfter[i] = condition;
         }
       }

       // returningAfter.sort(function(a, b) {
       //
       //    return a[1] - b[1];
       //  });
       for (var i = 0; i < returningAfter.length; i++) {
         if (returningAfter[i].unit === "minutes") {
           returningAfter[i].minutes = returningAfter[i].value;
         } else if (returningAfter[i].unit === "hours") {
           returningAfter[i].minutes = returningAfter[i].value * 60;

         } else {
           returningAfter[i].minutes = returningAfter[i].value * 60 *  24;
         }
       }
       returningAfter.sort(function (item1, item2) {
         return item1.minutes - item2.minutes;
       })
       for (var i = 0; i < returningAfter.length; i++) {
         delete returningAfter[i].minutes;
       }




        node.returningAfter = returningAfter;
        this.props.updateNode(node, this.props.node, true)
     }
     removeCondition(condition) {
       var node = this.props.node;
       for (var i = 0; i < node.returningAfter.length; i++) {
         if (node.returningAfter[i].id === condition.id) {
           node.returningAfter.splice(i,1);
           break;
         }
       }
       
       this.props.updateNode(node, this.props.node, true)

       
     }
     addConditionClicked() {
       var node = this.props.node;
       if (!node.returningAfter) {  node.returningAfter = [];  }
       // var foundAcceptableMinutes = false;
       // var minutes = 0;
       // while (!foundAcceptableMinutes) {
       //   minutes += 60;
       //   for (var i = 0; i < node.returningAfter.length; i++) {
       //     if (node.returningAfter[i].minutes != minutes) {
       //       foundAcceptableMinutes = true;
       //     }
       //   }
       // }
       var item = {id: RandomId(6), value:1, goto:null, unit:"hours" }

       if (node.returningAfter.length > 0) {
         let lastItem = node.returningAfter[node.returningAfter.length - 1];
         item.unit = lastItem.unit;
         item.value = lastItem.value + 1;
       }
       node.returningAfter.push(item)
       this.props.updateNode(node, this.props.node, true)

       
     }


    render() {
      

        var conditions:any = [];
        if (this.props.node.returningAfter) {
          for (var i = 0; i < this.props.node.returningAfter.length; i++) {
            var condition = this.props.node.returningAfter[i];
            conditions.push(<TimeSelect
                              title="Less than"
                              key={condition.id}
                              condition={condition}
                              value={condition.value}
                              unit={condition.unit}
                              updateCondition={this.updateCondition}
                              removeCondition={this.removeCondition} />)
          }

        }


        return <div>
              <div className="panel router_start_panel">
                <InspectorNodeHeader title="Router"/>

                {conditions}
                <div className="addElementButton" onClick={this.addConditionClicked}>Add Condition</div>





              </div>
            </div>;
     }
   }
}
export default RouterStart;
